import { render } from "./HitlFullEmbedDemo.vue?vue&type=template&id=20db665d&scoped=true"
import script from "./HitlFullEmbedDemo.vue?vue&type=script&lang=js"
export * from "./HitlFullEmbedDemo.vue?vue&type=script&lang=js"

import "./HitlFullEmbedDemo.vue?vue&type=style&index=0&id=20db665d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20db665d"]])

export default __exports__